import { MoveCoord } from '../../jscaip/MoveCoord';
export class GoMove extends MoveCoord {
    static PASS = new GoMove(-1, 0);
    static ACCEPT = new GoMove(-2, 0);
    static encoder = MoveCoord.getEncoder(GoMove.of);
    static of(coord) {
        return new GoMove(coord.x, coord.y);
    }
    toString() {
        if (this === GoMove.PASS) {
            return 'GoMove.PASS';
        }
        else if (this === GoMove.ACCEPT) {
            return 'GoMove.ACCEPT';
        }
        else {
            return 'GoMove(' + this.coord.x + ', ' + this.coord.y + ')';
        }
    }
}
